export default __webpack_public_path__ + "static/media/InsideBones_01.18916397.png";